import { observable, action, autorun, computed, toJS } from 'mobx'
import http from 'src/helper/http'
import { InitPage } from 'src/helper/tool'

export default class {
  @observable data = {
    lang: {}
  }
  @action async getLang(langMode) {
    let getLang = {
      en: {
        mode: 1,
        mainLang: 'English',
        langList: ['بالعربية', 'Türkçe', 'Português', 'indonésio', 'Русский', "O'zbek", 'فارسی', 'اردو'],
        title1: 'No words. Still felt',
        title2: 'the Loud & Social',
        title3: '',
        content:
          'Using App, you can talk and make friends with people all around the world, in a simple and reliable way.',
        about: 'About Us',
        contact: 'Contact Us',
        aboutCtx:
          'App is a mobile application for people to enjoy real-time voice chat of high quality. Yayya is simple to use, fun, and it includes diverse groups of users from all lover the world. It enables users to create multiple types of rooms, voice chat rooms, rooms to watch videos and rooms to electronic games. It helps every one to find people and stuff that they are interested.',
        recharge: 'Recharge',
        contactCtx: 'Email: service@yayya.live<br/> Phone：+86 13650820118',
        terms: 'Terms of Use'
      },
    }
    if (langMode === 'en') return getLang.en
    return getLang.en
  }
}

/**
 * 新增语种配置：
 *    按照上面的格式，配置语言对象，langList字段是前端展示的语言列表
 *    然后再通过 if 判断返回某个对象出去
 *    在前端页面操作流程：找到 changeLangMode 方法，传递某个语种的文字（mainLang），从而进行不同语种的设置。
 */



// WEBPACK FOOTER //
// src/store/home/pcnew.js